import React from "react"
import "../styles/profileStyles/footer.scss"
import { FaLinkedin } from "react-icons/fa"
import { FaGithub } from "react-icons/fa"

const Footer = () => {
  return (
    <footer>
      <div className="icon-left">
        <a
          href="https://www.linkedin.com/in/fahad-hussain23/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaLinkedin className="linkedIn icons" />
        </a>
      </div>

      <div className="name-and-email">
        <p>Fahad Hussain © {new Date().getFullYear()}</p>
        <p>sfahadh14@gmail.com</p>
      </div>
      
      <div className="icont-right">
        <a
          href="https://github.com/sfahadh"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaGithub className="github icons" />
        </a>
      </div>
    </footer>
  )
}

export default Footer
